import React from "react";
import Overlay from "../Overlay";
import SamplesAPI from "../../network/SamplesAPI";
import AdminAPI from "../../network/AdminAPI";

interface AdminHomePageState {
  showLoading?: boolean;
  facilitySamplesArray
  facilities
}

export default class AdminHomePage extends React.Component<
  any,
  AdminHomePageState
> {

  constructor(props) {
    super(props);
    this.state = {
      showLoading: false,
      facilitySamplesArray: [],
      facilities: []
    };
  }

  componentDidMount(): void {
    document.title = 'Admin Home Page';
    document.body.style.backgroundImage = ``;
    document.body.style.backgroundColor = '#FFFFFF'
    this.setState({ showLoading: true }, async () => {
      AdminAPI.getFacilitiesForSubmissionForm().then(data => {
        this.setState({facilities: data.authorizedFacilities})
      })
      SamplesAPI.getAllSamplesForAdminHome().then(data => {
        this.setState({
          facilitySamplesArray: data.facilitySamplesArray,
          showLoading: false,
        });
      })
      
    });
  }

  getCard(title, number, samples){
    if(title === 'Submitted' || title === 'Submitted (Animal)'){
      return (
        <div className="col-12 col-md-4">
          <div className="card mt-2 text-center font-weight-bold">
            <div
              className="card-header verlag-bold"
              style={{ cursor: "pointer" }}
              tabIndex={0}
              aria-label={`Samples Stats for ${this.state.facilities && this.state.facilities.length > 0 ? this.state.facilities.find(fa => fa.ID === samples[0][0].FacilityID).FacilityName : ''}` + ` - ${title}`}
              onClick={() => {
                window.location.href = `/admin/${title === 'Submitted' ? 'HumanSamples' : 'AnimalSamples'}?f=${samples[0][0].FacilityID}&p=0&c=0`
              }}
              onKeyPress={e => {
                if (e.key === "Enter" || e.key === " ") {
                  window.location.href = `/admin/${title === 'Submitted' ? 'HumanSamples' : 'AnimalSamples'}?f=${samples[0][0].FacilityID}&p=0&c=0`
                }
              }}
              role="button"
            >
              <h4>{title}</h4>
            </div>
            <div
              className="card-body hover-card"
              style={{ fontSize: '3rem', cursor: "pointer" }}
              tabIndex={0}
              aria-label={`Number of samples submitted for ${this.state.facilities && this.state.facilities.length > 0 ? this.state.facilities.find(fa => fa.ID === samples[0][0].FacilityID).FacilityName : ''}` + ` - ${title}`}
              onClick={() => {
                window.location.href = `/admin/${title === 'Submitted' ? 'HumanSamples' : 'AnimalSamples'}?f=${samples[0][0].FacilityID}&p=0&c=0`
              }}
              onKeyPress={e => {
                if (e.key === "Enter" || e.key === " ") {
                  window.location.href = `/admin/${title === 'Submitted' ? 'HumanSamples' : 'AnimalSamples'}?f=${samples[0][0].FacilityID}&p=0&c=0`
                }
              }}
              role="button"
            >
              {number || number === 0 ? number : 'N/A'}
            </div>
          </div>
        </div>
      )
    }
    else if(title === 'Processing' || title === 'Processing (Animal)'){
      return(
        <div className="col-12 col-md-4">
          <div className="card mt-2 text-center font-weight-bold">
            <div
              className="card-header verlag-bold"
              style={{ cursor: "pointer" }}
              tabIndex={0}
              aria-label={`Samples Stats for ${this.state.facilities && this.state.facilities.length > 0 ? this.state.facilities.find(fa => fa.ID === samples[0][0].FacilityID).FacilityName : ''}` + ` - ${title}`}
              onClick={() => {
                window.location.href = `/admin/${title === 'Processing' ? 'HumanSamples' : 'AnimalSamples'}?f=${samples[0][0].FacilityID}&p=1&c=0`
              }}
              onKeyPress={e => {
                if (e.key === "Enter" || e.key === " ") {
                  window.location.href = `/admin/${title === 'Processing' ? 'HumanSamples' : 'AnimalSamples'}?f=${samples[0][0].FacilityID}&p=1&c=0`
                }
              }}
              role="button"
            >
              <h4>{title}</h4>
            </div>
            <div
              className="card-body hover-card"
              style={{ fontSize: '3rem', cursor: "pointer" }}
              tabIndex={0}
              aria-label={`Number of samples processing for ${this.state.facilities && this.state.facilities.length > 0 ? this.state.facilities.find(fa => fa.ID === samples[0][0].FacilityID).FacilityName : ''}` + ` - ${title}`}
              onClick={() => {
                window.location.href = `/admin/${title === 'Processing' ? 'HumanSamples' : 'AnimalSamples'}?f=${samples[0][0].FacilityID}&p=1&c=0`
              }}
              onKeyPress={e => {
                if (e.key === "Enter" || e.key === " ") {
                  window.location.href = `/admin/${title === 'Processing' ? 'HumanSamples' : 'AnimalSamples'}?f=${samples[0][0].FacilityID}&p=1&c=0`
                }
              }}
              role="button"
            >
              {number || number === 0 ? number : 'N/A'}
            </div>
          </div>
        </div>
      )
    }
    else if(title === 'Completed' || title === 'Completed (Animal)'){
      return(
        <div className="col-12 col-md-4">
          <div className="card mt-2 text-center font-weight-bold">
            <div
              className="card-header verlag-bold"
              style={{ cursor: "pointer" }}
              tabIndex={0}
              aria-label={`Samples Stats for ${this.state.facilities && this.state.facilities.length > 0 ? this.state.facilities.find(fa => fa.ID === samples[0][0].FacilityID).FacilityName : ''}` + ` - ${title}`}
              onClick={() => {
                window.location.href = `/admin/${title === 'Completed' ? 'HumanSamples' : 'AnimalSamples'}?f=${samples[0][0].FacilityID}&p=0&c=1`
              }}
              onKeyPress={e => {
                if (e.key === "Enter" || e.key === " ") {
                  window.location.href = `/admin/${title === 'Completed' ? 'HumanSamples' : 'AnimalSamples'}?f=${samples[0][0].FacilityID}&p=0&c=1`
                }
              }}
              role="button"
            >
              <h4>{title}</h4>
            </div>
            <div
              className="card-body hover-card"
              style={{ fontSize: '3rem', cursor: "pointer" }}
              tabIndex={0}
              aria-label={`Number of samples completed for ${this.state.facilities && this.state.facilities.length > 0 ? this.state.facilities.find(fa => fa.ID === samples[0][0].FacilityID).FacilityName : ''}` + ` - ${title}`}
              onClick={() => {
                window.location.href = `/admin/${title === 'Completed' ? 'HumanSamples' : 'AnimalSamples'}?f=${samples[0][0].FacilityID}&p=0&c=1`
              }}
              onKeyPress={e => {
                if (e.key === "Enter" || e.key === " ") {
                  window.location.href = `/admin/${title === 'Completed' ? 'HumanSamples' : 'AnimalSamples'}?f=${samples[0][0].FacilityID}&p=0&c=1`
                }
              }}
              role="button"
            >
              {number || number === 0 ? number : 'N/A'}
            </div>
          </div>
        </div>
      )
    }
  }

  getSubmitted(array){
    return array.reduce((sum, r) => sum + (r.Status ? Number(r.count) : 0), 0);
  }

  getProcessing(array){
    const row = array.find(r => r.Status === 1);
    return row ? Number(row.count) : 0;
  }

  getCompleted(array){
    const row = array.find(r => r.Status === 2);
    return row ? Number(row.count) : 0;
  }
      

  render():
    | React.ReactElement
    | string
    | number
    | {}
    | React.ReactNodeArray
    | React.ReactPortal
    | boolean
    | null
    | undefined {

    return (
      <React.Fragment>
        <Overlay show_loading={this.state.showLoading} />
        <main id="main-content" tabIndex={-1} aria-label="Home Page Samples Statistics">
          <div className="container-fluid">
              <div className={"row"}>
                <div className="col-12 pt-2">
                  {this.state.facilitySamplesArray && this.state.facilitySamplesArray.length > 0 ? this.state.facilitySamplesArray.map((f, index) => {
                    return (
                    <article>
                    <div className={index > 0 ? "card mt-5" : "card mt-2"}>
                      <div
                        className="card-header verlag-bold"
                        role="region"
                        aria-labelledby={`facility-sample-stats-header-${f[0][0].FacilityID}`}
                      >
                        <div className="row">
                          <div className="col-12 text-center">
                            <h4
                              id={`facility-sample-stats-header-${f[0][0].FacilityID}`}
                              tabIndex={0}
                              aria-label={`Samples Stats for ${this.state.facilities && this.state.facilities.length > 0 ? this.state.facilities.find(fa => fa.ID === f[0][0].FacilityID).FacilityName : ''}`}
                            >
                              Samples Stats for {this.state.facilities && this.state.facilities.length > 0 ? this.state.facilities.find(fa => fa.ID === f[0][0].FacilityID).FacilityName : ''}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row" tabIndex={0} aria-label={`Samples Stats for ${this.state.facilities && this.state.facilities.length > 0 ? this.state.facilities.find(fa => fa.ID === f[0][0].FacilityID).FacilityName : ''}`}>
                      {f[0].length > 0 ? this.getCard('Submitted', this.getSubmitted(f[0]), f) : <></>}
                      {f[0].length > 0 ? this.getCard('Processing', this.getProcessing(f[0]), f) : <></>}
                      {f[0].length > 0 ? this.getCard('Completed', this.getCompleted(f[0]), f) : <></>}
                      
                      {f[1].length > 0 ? this.getCard('Submitted (Animal)', this.getSubmitted(f[1]), f) : <></>}
                      {f[1].length > 0 ? this.getCard('Processing (Animal)', this.getProcessing(f[1]), f) : <></>}
                      {f[1].length > 0 ? this.getCard('Completed (Animal)', this.getCompleted(f[1]), f) : <></>}
                    </div>
                    </article>
                    )
                  }
                    ) : (
                    <div className="col-12 pt-2">
                      <div className="card mt-2">
                        <div className="card-header verlag-bold">
                          <div className="row">
                            <div className="col-12 text-center">
                              <h5>No sample stats to show</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    )
                  }
                </div>
              </div>
          </div>
        </main>
      </React.Fragment>
    );
  }
}
